import * as React from "react";
import { convertPxToRem } from "../../../../utils";
import { useTranslation } from "react-i18next";
import {
  Checkbox,
  Stack,
  Typography,
  Button,
  FormControlLabel,
  Box,
} from "@mui/material";
import { useState } from "react";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";

export default function HowItWorksModal({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: (isDoNotShowThisAgain: boolean) => void;
}) {
  const [isDoNotShowThisAgain, setDoNotShowThisAgain] = useState(false);
  const { t } = useTranslation();

  function onDoNotShowThisAgainClick(e: any) {
    setDoNotShowThisAgain(e.target.checked);
  }

  return (
    <DefentSheet
      expanded={isOpen}
      onClose={() => handleClose(isDoNotShowThisAgain)}
    >
      <Stack
        paddingTop={convertPxToRem(34)}
        width="100%"
        alignItems={"center"}
        spacing={4}
      >
        <Stack alignItems={"center"} spacing={4}>
          <Box
            src={`/assets/HowItWorks/HowItWorks.svg`}
            height={160}
            my={2}
            alignSelf="flex-center"
            component="img"
            sx={{
              zIndex: 2,
            }}
            alt={t("HowItWorksModal.title")}
          />
          <Typography variant="h3" fontWeight={700} align="center">
            {t("HowItWorksModal.title")}
          </Typography>
        </Stack>
        <Stack style={{ marginTop: 16 }} spacing={2}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Typography fontWeight={500} align="center">
              {t("HowItWorksModal.topDescription")}
            </Typography>
            <Typography
              style={{ paddingTop: 16 }}
              fontWeight={500}
              align="center"
            >
              {String(t("HowItWorksModal.bottomDescription"))
                .split("<strong>")
                .map((part: string, i: number) => {
                  if (i === 0) return part;
                  const [boldText, ...rest] = part.split("</strong>");
                  return (
                    <React.Fragment key={i}>
                      <Typography
                        component="span"
                        fontWeight={700}
                        align="center"
                      >
                        {boldText}
                      </Typography>
                      {rest.join("</strong>")}
                    </React.Fragment>
                  );
                })}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center" alignItems="center">
            <FormControlLabel
              sx={{ margin: 0 }}
              control={
                <Checkbox
                  slotProps={{
                    input: {
                      "aria-label": t("HowItWorksModal.doNotShowThisAgain"),
                    },
                  }}
                  sx={{
                    paddingRight: 2,
                    color: "grey.200",
                    "&.Mui-checked": {
                      color: "primary",
                    },
                  }}
                  value={isDoNotShowThisAgain}
                  onChange={onDoNotShowThisAgainClick}
                />
              }
              label={t("HowItWorksModal.doNotShowThisAgain")}
            />
          </Stack>
        </Stack>
        <Button
          style={{ width: "100%", marginTop: convertPxToRem(34) }}
          onClick={() => handleClose(isDoNotShowThisAgain)}
        >
          {t("HowItWorksModal.doYoursNow")}
        </Button>
      </Stack>
    </DefentSheet>
  );
}
